import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dateGroup my-4" }
const _hoisted_2 = { class: "dateTitle my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleSlot = _resolveComponent("ScheduleSlot")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "secondaryTitle my-3" }, "Appointment Slots", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupByDate, (groupedByDateSlot) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(groupedByDateSlot.dateFormatted), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByDateSlot.slots, (slot) => {
          return (_openBlock(), _createElementBlock("div", null, [
            _createVNode(_component_ScheduleSlot, {
              slotByTime: slot,
              onSlotSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('slot-selected')))
            }, null, 8, ["slotByTime"])
          ]))
        }), 256))
      ]))
    }), 256))
  ]))
}